module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMP///9Hj8fa6fQ7iMPz+PuFtdq20ulgns6py+V4rdZUl8u7A2IQAAAAB3RSTlMAYL8AIM/vi50ITwAAAP1JREFUeF7t2DmOwzAUg2HJG7U7uf9lR+lZ0QQEDPzKv/iAIIksv/CbuJUHs8V9Ttj34ywP5zx+0HGVx3MdEzqLYc49xGKZGDYPtIVimn8BvVAiQFKgTKScBAhTIk2AkAdrAoQ6WBOgKbEmQKiNNQECGmsKhMaaAqGzpkDorCkQemJNgJATawI0JdYECHmwJkCogzUBmhJrAoTaWBMgoLEmQHyaC0J3QegqxCU/tP6j3a6vf90Psn5Yc/1p1x0j+cua66hdd/h31hY+IG/WXJeIddea+mHNdfVbdxnNX9bWXdiJk4RXCGle6IVsSxbb2se1iLKtxpzLujmO9eEfuIW9s/E+MYIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/23e9.png
// module id = 1327
// module chunks = 0